import React, { useState, useEffect } from 'react';
import { useAuth } from '../auth/AuthContext';
import errorMessages from '../constants/errorMessages';
import { getAccountStatement } from '../services/depositService';
import LoadingSpinnerComponent from '../components/LoadingSpinnerComponent';
import theme from '../theme/theme';
import '../assets/styles/accountStatement.css';
const AccountStatementSection = () => {
  const { empIdNumber } = useAuth(); 
  const [accountData, setAccountData] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);
 
  useEffect(() => {
    const loadAccountStatement = async () => {
      try {
        const data = await getAccountStatement(empIdNumber);
        setAccountData(data);
        setLoading(false);
      } catch (error) {
        setError(errorMessages.FETCH_DATA_ERROR);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    loadAccountStatement();
  }, [empIdNumber]);

  if (loading) return <LoadingSpinnerComponent spinnerColor={theme.colors.primary} />;
  if (error) return <div className="alert alert-danger">{error}</div>;

  const totalBalance = accountData.reduce((total, statement) => total + statement.totalScore, 0);

  return (
    <div className="account-statement-container my-5 p-4 border rounded shadow-lg" style={{ backgroundColor: '#f8f9fa' }}>
      {/* Header */}
      <h4 className="text-center mb-4" style={{ color: '#343a40', fontWeight: '700' }}>كشف حساب مفصل حسب العام الدراسي </h4>
      <div className="text-center">
        <span>العام الدراسي الميلادي يبدأ من شهر 8 اغسطس</span>
        <p className="text-danger">كشف الحساب هذا للنظام الجديد فقط، الرجاء الاطلاع على الارشيف بالاسفل للمزيد من المعلومات</p>
      </div>
      
      {/* Dynamic Statement Rows */}
      {accountData.map((statement, index) => (
        <div 
          key={index} 
          className="statement-row row justify-content-between align-items-center py-3 px-4 mb-3" 
          style={{ backgroundColor: '#ffffff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
        >
          <div className="statement-year col-12 col-md-3 text-start ltr-text" style={{ fontWeight: '600', fontSize: '1.1rem' }}>
            {statement.academicYear}
          </div>
          <div className="statement-details col-12 col-md-7 d-flex flex-column flex-md-row justify-content-around">
            <div>جميع الايداعات: <strong>{statement.depositsCount}</strong></div>
            <div>المقبولة: <strong className="text-success">{statement.acceptedDeposits}</strong></div>
            <div>المرفوضة: <strong className="text-danger">{statement.rejectedDeposits}</strong></div>
            <div>تحت المراجعة: <strong className="text-warning">{statement.pendingDeposits}</strong></div>
          </div>
          <div className="statement-balance col-12 col-md-2 text-end" >
           الرصيد :  <span style={{ fontWeight: '600', fontSize: '1.2rem', color: '#007bff' }}>{statement.totalScore}</span>
          </div>
        </div>
      ))}

      {/* Total Balance */}
      <div className="total-balance-row d-flex justify-content-center align-items-center py-3 px-4 mt-4" style={{ backgroundColor: '#e9ecef', borderRadius: '8px', fontWeight: '700', fontSize: '1.3rem', color: '#28a745' }}>
        الإجمالي: {totalBalance}
      </div>
    </div>
  );
};

export default AccountStatementSection;
